export default __webpack_public_path__ + "static/media/transaction.b8253bbe.svg";